const queryParamsToObject = (queryParamsString) => {
    let searchParams = queryParamsString;
    if (queryParamsString.includes('?')) {
        searchParams = searchParams.substring(1);
    }
    const params = new URLSearchParams(searchParams);
    const errorObjectParams = {};
    params.forEach((value, key) => {
        errorObjectParams[key] = value;
    });
    return errorObjectParams;
};
export default queryParamsToObject;
//# sourceMappingURL=queryParamsToObject.js.map